export const MEDICARE = 'medicare-formatter';
import { createAlphanumericFormatter } from '@philips-internal/oswald-ui-model/lib/generators/';
function isValid(medicareNumber) {
    const medicareDigits = (medicareNumber || '').toString().replace(/[./-]/g, '');
    const PATTERN = /^([2-6]\d{7})(\d)/;
    const matches = medicareDigits.match(PATTERN);
    const isLengthValid = medicareDigits.length >= 10 && medicareDigits.length <= 13;
    let valid = false;
    if (!matches) {
        return valid;
    }
    if (medicareDigits && isLengthValid && matches) {
        const base = matches[1];
        const checkDigit = matches[2];
        const weights = [1, 3, 7, 9, 1, 3, 7, 9];
        let sum = 0;
        for (let i = 0; i < weights.length; i++) {
            sum += parseInt(base[i], 10) * weights[i];
        }
        valid = sum % 10 === parseInt(checkDigit, 10);
    }
    else {
        valid = false;
    }
    return valid;
}
const MedicareFormatter = createAlphanumericFormatter({
    invalidMessage: 'patient.medicare-validator',
    mask: '9999999999 ?9?9?9',
    name: MEDICARE,
    validate: isValid,
});
export default MedicareFormatter;
//# sourceMappingURL=medicare-formatter.js.map